import { roleHasPermission } from "@crewledger/shared/auth";
import { useAuth } from "@/features/auth/auth-provider";

export function useReportPermissions() {
  const { user } = useAuth();
  const role = (user?.role ?? "EMPLOYEE") as Parameters<typeof roleHasPermission>[0];

  return {
    canRead: roleHasPermission(role, "reports:read"),
    canViewPayroll: roleHasPermission(role, "payroll:sensitive"),
    isReadOnly: role === "AUDITOR" || role === "SITE_MANAGER",
    role,
  };
}
